import {
  SnackbarProvider as BaseSnackbarProvider,
  SnackbarProviderProps as BaseSnackbarProviderProps,
} from 'notistack'
import { Success } from 'shared/icons'
import { Slide } from './SnackbarProvider.style'

const AUTO_HIDE_DURATION = 4000

interface SnackbarProviderProps extends BaseSnackbarProviderProps {}

const SnackbarProvider = ({ ...props }: SnackbarProviderProps) => (
  <BaseSnackbarProvider
    autoHideDuration={AUTO_HIDE_DURATION}
    iconVariant={{
      success: <Success />,
    }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    TransitionComponent={Slide}
    {...props}
  />
)

export default SnackbarProvider
